import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FieldActionEvent } from '../dynamic-field.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreDirectivesModule } from '@core/directives/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlatpickrModule } from 'angularx-flatpickr';
import { SelectFieldComponent } from 'app/main/pages/contract-control/editable-fields/select-field/select-field.component';
import { TextFieldComponent } from 'app/main/pages/contract-control/editable-fields/text-field/text-field.component';
import { ExtractSenderDetailPipe } from 'app/pipes/documents-right-sidebar-pipes/extract-sender-details.pipe';
import { MomentPipe } from 'app/pipes/moment.pipe';
import { UserTimeZoneFormatPipe } from 'app/pipes/user-timezone-format.pipe';
import { TranslocoRootModule } from 'app/transloco-root.module';

@Component({
  selector: 'app-contract-control-field',
  standalone: true,
  imports: [
    CommonModule,
    CoreDirectivesModule,
    TranslocoRootModule,
    NgSelectModule,
    TextFieldComponent,
    SelectFieldComponent,
    NgbTooltipModule,
    ExtractSenderDetailPipe,
    FlatpickrModule,
    MomentPipe,
    UserTimeZoneFormatPipe,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './contract-control-field.component.html',
  styleUrl: './contract-control-field.component.scss'
})
export class ContractControlFieldComponent {
 
  @Input() documentData: any;
  @Output() actionEmit = new EventEmitter<FieldActionEvent>();

  get hasLinkedContracts(): boolean {
    return this.documentData?.contract_control_multi_sections?.length > 0 && this.contractId;
  }

  get contractName(): string {
    return this.documentData?.contract_control_multi_sections?.[0]
      ?.contract_control?.contract_control_name || '';
  }

  get contractId(): any {
    return this.documentData?.contract_control_multi_sections?.[0]
      ?.contract_control?.id;
  }

  openContractControl() {
    this.actionEmit.emit({ action: 'openContractControl' });
  }

  navigateToContract() {
    this.actionEmit.emit({ 
      action: 'navigateToContract', 
      data: this.contractId 
    });
  }
}
